export default "/fonts/vendor/katex/dist/KaTeX_Size3-Regular.ttf?8d6b6822586eea3d3b2076d171808949";